import { apiClient } from './api'

export interface ProgramKPI {
  id: number
  program_id: number
  kpi_type: 'schedule' | 'budget' | 'scope' | 'resource' | 'stakeholder'
  current_value: number
  trend: number
  status: 'At Risk' | 'On Track' | 'Excellent'
  calculated_at: string
  metadata?: Record<string, unknown>
}

export const programKpiService = {
  async list(programId: number, includeHistory?: boolean): Promise<ProgramKPI[]> {
    const response = await apiClient.get<ProgramKPI[]>(`/api/v1/programs/${programId}/kpis`, {
      params: { include_history: includeHistory }
    })
    return response.data
  },

  async get(programId: number, kpiId: number): Promise<ProgramKPI> {
    const response = await apiClient.get<ProgramKPI>(`/api/v1/programs/${programId}/kpis/${kpiId}`)
    return response.data
  },

  async calculate(programId: number): Promise<ProgramKPI[]> {
    const response = await apiClient.post<ProgramKPI[]>(`/api/v1/programs/${programId}/kpis/calculate`)
    return response.data
  },

  async update(programId: number, kpiId: number, data: Partial<ProgramKPI>): Promise<ProgramKPI> {
    const response = await apiClient.put<ProgramKPI>(`/api/v1/programs/${programId}/kpis/${kpiId}`, data)
    return response.data
  }
}

